import React from "react";
import { FormControl, ControlLabel, Alert } from "react-bootstrap";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import TCClockEditForm from "./tc-clock-edit/tc-clock-edit-form.jsx";
import moment from "moment";
import immutable from "immutable";
import TCButtonPanel from "./shared/tc-button-panel.jsx";
import { browserHistory } from "react-router";

export default class PayrollAdminTCClockEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weekEndings: [],
            selectedTimecardId: null,
            selectedWeekEnding: null,
            timecard: null,
            hideButtonPanel: true,
            buttons: "",
            errors: [],
            isIncomplete: false,
            requireNotes: false,
        };

        this.role = context.getRouteParam(this, "role");
        this.statusCode = null;

        this.onLoadTimecardCompleted = this.onLoadTimecardCompleted.bind(this);
        this.prepareButtonPanel = this.prepareButtonPanel.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onVerify = this.onVerify.bind(this);
        this.onRecallApproved = this.onRecallApproved.bind(this);
        this.handleErrors = this.handleErrors.bind(this);
    }

    onSubmit() {
        const self = this;
        let vm = this.state;
        const timecardId = this.state.timecard.timecardId;

        context.message({
            show: true,
            type: "loading",
            message: "Preparing to submit timecard..."
        });
        let newNotes = this.refs.tcClockEditForm.refs.tcSummary.getNotes().trim();
        ajax.api()
            .put(`add-notes/${timecardId}`, { role: self.role, notes: newNotes })
            .then(function (res) {
                ajax.api()
                    .get(`prepare-timecard-submission/${timecardId}`)
                    .then(function (res) {
                        const redirectFunc = function () {
                            context.message({
                                show: true,
                                message: "Preparing to submit timecard...",
                                type: "loading"
                            });

                            const submitToken = res.data.token;
                            browserHistory.push(context.routeUrl(`${self.role}/tc-submit/${submitToken.timecardId}/${escape(submitToken.token)}`));
                            context.message({ show: false });
                        };

                        if (res.data.warningMessages && res.data.warningMessages.length > 0) {
                            let liKey = 1;
                            context.message({
                                show: true,
                                type: 'warning',
                                message: <div>
                                    <ul>
                                        {res.data.warningMessages.map(w => <li key={liKey++}>{w}</li>)}
                                    </ul>
                                    <p>
                                        Are you sure to submit this timecard?
                                    </p>
                                </div>,
                                buttons: "yes,no"
                            }, function (button, s) {
                                if (button == "yes") {
                                    redirectFunc();
                                } else {
                                    context.message({ show: false });
                                }
                            });
                        } else if (res.data.errorMessages && res.data.errorMessages.length > 0) {
                            self.handleErrors(res.data.errorMessages);
                            setTimeout(() => context.message({ show: false }), 1);
                        } else {
                            redirectFunc();
                        }
                    })
                    .catch(function (err) {
                        const error = err.response.data.exceptionMessage || err.response.data.message;
                        self.handleErrors(error);
                        setTimeout(() => context.message({ show: false }), 1);
                    });
            })
            .catch(function (err) {
                const error = err.response.data.exceptionMessage || err.response.data.message;
                self.handleErrors(error);
                setTimeout(() => context.message({ show: false }), 1);
            });
    }

    componentDidMount() {
        this.loadPage();
    }

    onVerify() {
        context.message({
            show: true,
            type: "loading",
            message: "Preparing for Verification. Please wait...",
        });

        let self = this;
        const timecardId = this.state.timecard.timecardId;
        let newNotes = this.refs.tcClockEditForm.refs.tcSummary.getNotes().trim();
        let submitted = this.statusCode == "saved" ? 0 : 1;

        ajax.api()
            .post("payroll-admin/prepare-timecard-verification", {
                timecards: [timecardId],
                submitted: submitted
            })
            .then(res => {
                const data = res.data[0];
                console.log(data);
                if (data.errorMessages.length > 0) {
                    self.handleErrors(data.errorMessages);
                    setTimeout(() => context.message({ show: false }), 1);
                } else {
                    const redirect = () => {
                        browserHistory.push(context.routeUrl(`${self.role}/tc-approval/${submitted}`));
                    };
                    if (data.warningMessages.length > 0) {
                        let liKey = 0;
                        context.message({
                            show: true,
                            type: 'warning',
                            message: <div>
                                <ul>
                                    {data.warningMessages.map(w => <li key={liKey++}>{w}</li>)}
                                </ul>
                                <p>
                                    Are you sure to verify this timecard?
                                </p>
                            </div>,
                            buttons: "yes,no"
                        }, function (button, s) {
                            if (button == "yes") {
                                context.message({
                                    show: true,
                                    type: "loading",
                                    message: "Processing. Please wait...",
                                });
                                setTimeout(redirect, 1);
                            } else {
                                context.message({ show: false });
                            }
                        });
                    } else redirect();

                }
            })
            .catch(err => {
                const error = err.response.data.exceptionMessage || err.response.data.message;
                self.handleErrors(error);
                setTimeout(() => context.message({ show: false }), 1);
            });
    }

    onRecallApproved() {
        let self = this;
        let newNotes = this.refs.tcClockEditForm.refs.tcSummary.getNotes().trim();
        const timecardId = this.state.timecard.timecardId;

        if (newNotes == null || newNotes.length < 1) {
            context.message({
                show: true,
                type: "error",
                message: <div>Notes is required</div>,
                buttons: "ok"
            });
            return false;
        }

        context.message({
            show: true,
            type: "info",
            message: "Are you sure you want to recall this timecard?",
            buttons: "yes,no"
        }, function (button, s) {
            // s is timecardId, timecardId is set as the 3rd parameter of context.message
            if (button === "yes") {
                ajax.api()
                    .put("recall-approved-timecard", { timecardId: timecardId, notes: newNotes })
                    .then(function (res) {
                        self.refs.tcClockEditForm.loadTimecard(timecardId);
                    })
                    .catch(function (err) {
                        const data = err.response.data;
                        const msg = data.exceptionMessage || data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: <div>Error while recalling timecard.<br />{msg}</div>,
                            buttons: "ok"
                        });
                    });
            }
        }, timecardId);
    }

    loadPage() {
        const tid = this.props.params.timecardId;
        let self = this;
        // ajax.vm()
        //     .get("people/tc-clock-edit")
        //     .then(function (res) {
        //         const data = res.data;
        //         if (tid) {
        //             for (let i = 0; i < data.weekEndings.length; i++) {
        //                 if (tid == data.weekEndings[i].timecardId) {
        //                     data.selectedTimecardId = data.weekEndings[i].timecardId;
        //                     data.selectedWeekEnding = moment(data.weekEndings[i].weekEnding).format("MM/DD/YYYY");
        //                 }
        //             }
        //         }
        //         console.log(data);
        //         self.setState(data);
        //     });

    }

    onLoadTimecardCompleted(tc, errors) {
        const clone = immutable.fromJS(this.state).toJS();
        const buttonConfig = this.prepareButtonPanel(tc);
        clone.timecardId = tc.timecardId;
        clone.timecard = tc;
        clone.weekEnding = moment(tc.weekEnding).format("MM-DD-YYYY");
        clone.hideButtonPanel = buttonConfig.hideButtonPanel;
        clone.buttons = buttonConfig.buttons;
        clone.requireNotes = buttonConfig.requireNotes;
        clone.isIncomplete = this.refs.tcClockEditForm.isIncomplete();
        clone.errors = (errors == null) ? [] : errors;
        this.statusCode = tc.statusCode.toLowerCase();
        this.setState(clone);
    }

    prepareButtonPanel(tc) {

        const result = {
            hideButtonPanel: true,
            buttons: "",
            requireNotes: false
        };
        if (tc) {
            const statusCode = tc.statusCode.toLowerCase();
            if (statusCode === "saved") {
                result.hideButtonPanel = false;
                result.buttons = "submit,verify";
                result.requireNotes = false;
            } else if (statusCode === "submitted") {
                result.hideButtonPanel = false;
                result.buttons = "verify";
                result.requireNotes = false;
            } else if (statusCode === "approved") {
                result.hideButtonPanel = false;
                result.buttons = "recall-approved";
                result.requireNotes = true;
            }
        }

        return result;
    }

    createNewTimecard() {
        const clone = immutable.fromJS(this.state).toJS();
        clone.selectedTimecardId = -1;
        this.setState(clone);
    }

    handleErrors(errors) {
        const clone = immutable.fromJS(this.state).toJS();
        if (typeof (errors) == "string") clone.errors = [errors];
        else clone.errors = errors;
        this.setState(clone, function () { window.scrollTo(0, 0); });
    }

    render() {
        const buttonPanel = !this.state.hideButtonPanel ?
            <TCButtonPanel buttons={this.state.buttons}
                hidden={this.state.hideButtonPanel}
                onSubmit={this.onSubmit}
                onVerify={this.onVerify}
                onRecallApproved={this.onRecallApproved} /> : null;
        const tc = this.state.timecard;
        let alert = null, errors = null;
        if (this.state.errors.length > 0) {
            errors = <Alert bsStyle="danger"><ul>
                {
                    this.state.errors.map(err => <li key={err}>{err}</li>)
                }
            </ul></Alert>
        }
        let hideGrid = (tc && moment(tc.weekEnding).endOf("week").format("YYYYMMDD") > moment().endOf("week").format("YYYYMMDD")); // hide if future timecard
        let allowEdit = true;

        /// knguyen : 12/6/2017 - Enable edit on Processed timecard for payroll-admin, disable for Approved timecard
        if (tc && tc.statusCode.toLowerCase() !== "saved" && tc.statusCode.toLowerCase() !== "submitted") {
            if (tc.statusCode.toLowerCase() == "approved") {
                allowEdit = false;
            }
            alert = <Alert bsStyle="warning">Timecard for the weekend {moment(tc.weekEnding).format("MM/DD/YYYY")} has been {tc.statusCode.toLowerCase()} already!</Alert>;
        }

        return (
            <div className="ap-form-container">
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-12 text-center ap-h1">
                            Verify Timecards: Details
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            <Alert bsStyle="info">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Timecard ID:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6">
                                            <b>{tc ? tc.timecardId : ""}</b>
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Week Ending:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 ">
                                            <b>{tc ? moment(tc.weekEnding).format("MM/DD/YYYY") : ""}</b>
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Employee Name:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 ">
                                            <b>{tc ? tc.peopleName : ""}</b>
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Report To:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 ">
                                            <b>{tc ? tc.reportToName : ""}</b>
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 text-right">
                                            Position:
                                        </div>
                                        <div className="col-md-3 col-xs-6 col-sm-6 ">
                                            <b>{tc ? tc.jobTitle : ""}</b>
                                        </div>
                                    </div>
                                </div>
                            </Alert>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {alert}
                            {errors}
                        </div>
                    </div>
                </div>

                <TCClockEditForm timecardId={this.props.params.timecardId} onNewTimecardAdded={this.onNewTimecardAdded} ref="tcClockEditForm"
                    onLoadTimecardCompleted={this.onLoadTimecardCompleted} weekEnding={tc ? tc.weekEnding : null} allowEdit={allowEdit}
                    role={this.role} showAltered="true" hideGrid={hideGrid} requireNotes={this.state.requireNotes} />
                {buttonPanel}
            </div>
        );
    }
}
